export default "__VITE_ASSET__By0it7tD__"